<template>
  <div class="login-holder">
    <div class="login-box">
      <div class="container-fluid">
        <img src="../assets/logo.png" alt="PropertyPistol Syndicate Logo" />
        <form @submit.prevent="login">
          <div class="form-group">
            <input
              type="email"
              class="form-control p-4"
              placeholder="Email"
              required
              ref="email"
            />
          </div>

          <div class="form-group">
            <input
              :type="showPass ? 'text' : 'password'"
              class="form-control p-4"
              placeholder="Password"
              ref="password"
              required
              minlength="6"
            />
          </div>

          <div class="form-group">
            <button type="submit" class="btn btn-primary mt-5 btn-block">
              Login
            </button>
          </div>
            <div class="form-group">
            <router-link :to="{name: 'ForgotPassword'}" class="btn  mt-3 text-link mx-auto d-block f14">
              Forgot Password
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPass: false,
    };
  },
  methods: {
    login() {
      let email = this.$refs.email.value
      let password = this.$refs.password.value
      if(email.length > 0 && password.length > 0){
        this.$axios.post('login', {email, password})
          .then(res => {
            localStorage.setItem('s-o-user-name', res.data.data.name);
            localStorage.setItem('s-o-user-email', res.data.data.email);
            localStorage.setItem('s-o-token', res.data.data.token);
            this.$router.replace('/');
          })
          .catch(err => {
            swal({
              title: "Login Failed",
              text: err.response.data.message,
              icon: "error"
            })
          })
      }else{
        swal({
          title: "Please enter Email and Password",
          icon: "info"
        })
      }
    },
  },
};
</script>
<style scoped>
.login-holder {
  height: 100vh;
  position: relative;
  background: #fff;
}
.login-box {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translate(0, -50%);
}
.login-box img {
  margin: 0 auto 100px;
  display: table;
  max-width: 190px;
}
.f14{
  font-size:14px ;
}
</style>